if (!document.documentElement.hasAttribute('data-shipping-protection-audit-ready')) {
  document.documentElement.setAttribute('data-shipping-protection-audit-ready', 'true');

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('[data-shipping-protection-decline-checkbox]');
    if (!checkbox) return;

    const container = checkbox.closest('[data-shipping-protection-decline]');
    if (!container) return;

    container.querySelectorAll('[data-shipping-protection-audit-field]').forEach(function (field) {
      field.disabled = !checkbox.checked;
      if (!field.hasAttribute('data-shipping-protection-timestamp')) {
        field.value = checkbox.checked ? field.getAttribute('data-audit-value') : '';
      }
    });

    const timestamp = container.querySelector('[data-shipping-protection-timestamp]');
    if (timestamp) timestamp.value = checkbox.checked ? new Date().toISOString() : '';
  });
}
